import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex h-100 w-100" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "xml_editor",
    class: "w-100 h-100"
  })
], -1)

import { onMounted, ref } from "vue";
import "brace";
import "brace/mode/javascript";
import "brace/mode/xml";
import "brace/theme/chrome";
import { StringUtils } from "../../utils/StringUtils";
import { blocklyStore } from "../../blockly/blocklyStore";
import { GlobalImport } from "../../utils/GlobalImport";

export default /*#__PURE__*/_defineComponent({
  __name: 'BlocklyXmlSection',
  setup(__props) {

const Blockly = GlobalImport.getBlockly();
const ace = GlobalImport.getAce();

/**
 * エディタを生成
 */
const xml_text = ref("");
const editor = ref(null);
onMounted(() => {
  const xml = Blockly.Xml.workspaceToDom(blocklyStore.workspace);
  xml_text.value = StringUtils.formatXml(Blockly.Xml.domToText(xml));

  editor.value = ace.edit("xml_editor");
  editor.value.getSession().setMode("ace/mode/xml");
  editor.value.setTheme("ace/theme/chrome");
  editor.value.setFontSize(18);
  editor.value.focus();
  editor.value.setReadOnly(true);
  editor.value.setValue(xml_text.value);
});

const removeId = () => {
  const xml = Blockly.Xml.textToDom(xml_text.value);
  // xmlからIDを除去
  const removeIdFromBlock = (tagName) => {
    const blocks = xml.getElementsByTagName(tagName);
    for (const b of blocks) {
      b.removeAttribute("id");
    }
  };
  removeIdFromBlock("block");
  removeIdFromBlock("shadow");

  const xmlData = StringUtils.formatXml(Blockly.Xml.domToText(xml));
  editor.value.setValue(xmlData);
  // editor.value.setValue(StringUtils.htmlEncode(xmlData));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex" }, [
      _createElementVNode("button", {
        class: "btn btn-info btn-lg",
        onClick: removeId
      }, "ID属性を除去")
    ]),
    _hoisted_2
  ]))
}
}

})